'use es6';

import PropTypes from 'prop-types';
import { getColors } from 'reporting-ui-components/reports/utils/colors/chartColors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LineChartIcon = ({
  colorSeriesType = 'DEFAULT',
  size = 25
}) => {
  const colors = getColors(colorSeriesType, [0, 1]);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("svg", {
      width: size,
      height: size,
      viewBox: "0 0 80 80",
      children: [/*#__PURE__*/_jsx("polyline", {
        fill: "none",
        stroke: colors[0],
        strokeWidth: "6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: "10",
        points: "4,73 52,8 76,45 "
      }), /*#__PURE__*/_jsx("polyline", {
        fill: "none",
        stroke: colors[1],
        strokeWidth: "6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: "10",
        points: "4,39 26,9 50,41 76,6"
      })]
    })
  });
};
LineChartIcon.propTypes = {
  size: PropTypes.number,
  colorSeriesType: PropTypes.string
};
export default LineChartIcon;